// Order fields shown on the PDV ("Registrar pedido"). The client page and the
// add-order form both need them, so one request is shared per place and kept
// for a few minutes. The settings page clears it after editing a field.
export const PDV_ORDER_FIELDS_URL = "order-fields?with-options=1&show-on-pdv=1";
export const PDV_ORDER_FIELDS_TTL_MS = 5 * 60 * 1000;

const cache = new Map();

export function loadPdvOrderFields(placeId, fetcher, now = Date.now) {
    const key = String(placeId || "");
    const hit = cache.get(key);
    if (hit && now() - hit.at < PDV_ORDER_FIELDS_TTL_MS) {
        return hit.promise.then(clone);
    }

    const promise = Promise.resolve()
        .then(fetcher)
        .catch((error) => {
            cache.delete(key);
            throw error;
        });
    cache.set(key, { at: now(), promise });
    return promise.then(clone);
}

export function clearPdvOrderFieldsCache() {
    cache.clear();
}

function clone(fields) {
    return JSON.parse(JSON.stringify(fields || []));
}
